<div
    class="h-full flex flex-col bg-white rounded-xl transition-all duration-300 backdrop-blur-md {{darkThemeClass}}"
    [style.padding]="padding"
    [ngClass]="{
        'shadow-sm': showShadow,
        'border': showBorder,
        'border-slate-100': showBorder,
        'dark:border-slate-800/50': showBorder
    }">
    <!-- Header Section -->
    <div class="mb-4" *ngIf="config.title || config.subtitle">
        <h3 class="text-base text-[#141437] dark:text-white m-0 mb-1 leading-snug">
            {{ config.title }}
        </h3>
        <p *ngIf="config.subtitle" class="text-sm text-gray-500 dark:text-slate-400 m-0 leading-snug">
            {{ config.subtitle }}
        </p>
    </div>

    <!-- Chart Container -->
    <div class="flex-1 min-h-0 flex items-center justify-center">
        <div #chartContainer 
             class="flex items-center justify-center overflow-visible"
             [style.width]="width"
             [style.height]="height"
             [style.min-height]="min_height"></div>
    </div>

    <!-- Stats Summary (Bottom) -->
    <div *ngIf="showLegends"
        class="mt-6 mb-3 flex flex-wrap gap-x-6 gap-y-3 justify-center border-t border-slate-50 dark:border-slate-800/50 pt-5">
        @for (d of data; track d.label) {
        <div class="flex items-center gap-2.5 group">
            <div class="w-2 h-2 rounded-full shadow-sm" [style.background]="d.color || '#3b82f6'"></div>
            <span class="text-xs font-medium" [ngClass]="!showLegendColor ? 'text-slate-400 dark:text-slate-500' : ''" [ngStyle]="{color: showLegendColor ? d.color : ''}" >{{ d.legend || d.label }}</span>
        </div>
        }
    </div>


</div>